import { DeliveryState, DeliveryStateExplanation } from '../../enums/orders';
import { StateStamp } from '../../interfaces/delivery-company/orders';
import { getDeliveryStateIcon } from '../common/styles/order-states.style';

export interface Step {
  label: string;
  icon: JSX.Element;
  timestamp?: string;
  helperText: string;
  done: boolean;
}

const standard_delivery_path: DeliveryState[] = [
  DeliveryState.CREATED,
  DeliveryState.PICKUP_REQUESTED,
  DeliveryState.PICKUP_ASSIGNED,
  DeliveryState.SCANNED_FOR_PICKUP,
  DeliveryState.PICKED_UP,
  DeliveryState.AT_WAREHOUSE,
  DeliveryState.DELIVERY_ASSIGNED,
  DeliveryState.SCANNED_FOR_DELIVERY,
  DeliveryState.PICKED_UP_FOR_DELIVERY,
  DeliveryState.IN_TRANSIT,
  DeliveryState.DELIVERED,
];

const expectedNextStates = (state: string): DeliveryState[] => {
  // Failed Delivery
  if (state === DeliveryState.AWAITING_RETURN) {
    return [DeliveryState.AT_WAREHOUSE];
  }

  // Terminal States
  if (
    [
      DeliveryState.DELIVERED,
      DeliveryState.DELIVERED_AT_WAREHOUSE,
      DeliveryState.CANCELLED,
    ].includes(state as DeliveryState)
  ) {
    return [];
  }

  const currentIndex = standard_delivery_path.indexOf(state as DeliveryState);
  return currentIndex < 0
    ? []
    : standard_delivery_path.slice(currentIndex + 1);
};

const getStateIcon = (
  state: DeliveryState,
  done: boolean,
  error: boolean
): JSX.Element => {
  let color = 'grey';

  if (done) {
    color = error ? '-d' : 'green';
  }

  const iconStyle = { style: { color, fontSize: 40 } };

  return getDeliveryStateIcon(state, iconStyle);
};

export const generateStateTrace = (state_history: StateStamp[]): Step[] => {
  const result: Step[] = [];

  // Completed states
  state_history.forEach((stateStamp, index) => {
    if (
      index - 1 >= 0 &&
      state_history[index - 1].delivery_state === state_history[index].delivery_state
    ) {
      return;
    }

    const isError = stateStamp.delivery_state === DeliveryState.CANCELLED;

    result.push({
      icon: getStateIcon(stateStamp.delivery_state, true, isError),
      label: stateStamp.delivery_state,
      timestamp: stateStamp.timestamp,
      helperText: DeliveryStateExplanation[stateStamp.delivery_state],
      done: true,
    });
  });

  // Future / pending states
  if (state_history.length > 0) {
    const lastState = state_history[state_history.length - 1].delivery_state;
    const pendingStates = expectedNextStates(lastState);

    pendingStates.forEach((state) => {
      result.push({
        icon: getStateIcon(state, false, false),
        label: state,
        helperText: DeliveryStateExplanation[state],
        done: false,
      });
    });
  }

  console.log('state trace = ', result);
  return result;
};
